import { type SxProps } from "@mui/material";
import Box from "@mui/material/Box";
import { type FC, type PropsWithChildren } from "react";


export type DrawerStepProps = PropsWithChildren<{
	value: number;
	index: number;
	sx: SxProps;
}>

export const DrawerStep: FC<DrawerStepProps> = ({
	children,
	value,
	index,
	sx,
	...rest
}) => {
	return (
		<Box
			role="tabpanel"
			hidden={value !== index}
			id={`simple-tabpanel-${index}`}
			aria-labelledby={`simple-tab-${index}`}
			sx={{ position: "relative", minHeight: "100%", ...sx }} // https://stackoverflow.com/questions/8468066/child-inside-parent-with-min-height-100-not-inheriting-height
			{...rest}
		>
			{value === index && <>{children}</>}
		</Box>
	);
}

